import React from 'react';
import { GlobalState } from '../models/app';

export const StateContext = React.createContext<GlobalState>({
    state: {
        context: undefined,
        account: undefined
    }
});
